import styled from "styled-components";

export const StyledLabelWrapper = styled.div`
  ${(props) =>
    props.$readonly
      ? `
    pointer-events: none;
    position: fixed;
    top: 0;
    left: -9999px;
  `
      : ``}
`;

export const StyledLabel = styled.div`
  position: relative;
  background-color: white;
  border: 1px dashed
    ${(props) =>
      !props.$readonly
        ? props.selected
          ? props.theme.colors.accent.normal
          : "black"
        : "transparent"};

  &:hover {
    border-color: ${(props) => props.theme.colors.accent.normal};
  }
`;

export const StyledLabelItem = styled.div`
  border: 1px dashed
    ${(props) =>
      !props.$readonly
        ? props.selected
          ? props.theme.colors.accent.normal
          : "black"
        : "transparent"};
  color: black;

  &:hover {
    border-color: ${(props) => props.theme.colors.accent.normal};
  }

  & * {
    pointer-events: none;
  }
`;
